var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-link-container"},[_c('a',{staticClass:"back-link",on:{"click":function($event){_vm.onBack ? _vm.onBack() : _vm.onBackToUrl()}}},[_c('BIconArrowLeft',{staticClass:"mr-2"}),_vm._v(_vm._s(_vm._f("i18n")('back'))+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }